import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Inputs from "../../components/inputs/Inputs";
import MyDialog from "../../components/dialog/Dialog";
import MySpinner from "../../components/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import { addSideEffects, updateSideEffects } from "../../app/sideEffectsSlice";
import { addDispodedItems } from "../../app/disposedItemsSlice";
import { customerSchema, disposeSchema, hasAccess, invoiceSchema, isAdmin, orderSchema, paymentSchema } from "../../common/validators";
import validate from "validate.js";
import { addOrder, getOrderItems, updateOrder } from "../../app/ordersSlice";
import moment from "moment";
import { PDFDownloadLink, PDFViewer,  } from "@react-pdf/renderer";
import { CircularProgress } from "@material-ui/core";
import InvoiceDoc from "../../components/table/invoice";
import { getInvoicesList, getPaymentsByInvoice, postPayment, putInvoice } from "../../api/invoicesAPI";
import { toast } from "react-toastify";


// PDFView

const itemsTableHead = [
  { label: "Invoice date", name: "invoice_date" },
  { label: "Customer Name", name: "customer_name" },
  { label: "Mobile", name: "customer_mobile" },
  // { label: "Email", name: "customer_email" },
  { label: "Status", name: "status" },
  { label: "Invoice number", name: "invoice_no" },
  { label: "Invoice amount", name: "invoice_amount" },
  { label: "Paid amount", name: "paid_amount" },
  { label: "Unpaid amount", name: "unpaid_amount" },  
  "action",
];


const paymentsTableHead = [
  { label: "Date", name: "payment_date" },
  { label: "Paid amount", name: "amount" },
  "action",
];

const isViewAccess = () => {
  return hasAccess('orders','view');
}



const Invoices = () => {
  let [isEdit, setIsEdit] = useState(false);
  let [isPay, setIsPay] = useState(false);  
  let [isPosting, setIsPosting] = useState(false);  
  let [isDetails, setIsDetails] = useState(false);
  let [openForm, setOpenForm] = useState(false);
  let [isLoading, setIsLoading] = useState(false);
  let [viewDetailsSelected, setViewDetailsSelected] = useState(false);
  let [hideSaveButton, setHideSaveButton] = useState(false);
  const [errors, setErrors] = useState([]);
  const [formValues, setFormValues] = useState({"invoice_date": new Date()});
  const [selectedItem, setSelectedItem] = useState({});
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoicePayments, setInvoicePayments] = useState([]);
  const [showPayments, setShowPayments] = useState(false);  
  
  
  
  const dispatch = useDispatch(); 


  const handleRequestClose = () => {
    setErrors([])
    setOpenForm(false);
    setIsDetails(false);   
    setIsEdit(false);
    setIsPay(false);
    setShowPayments(false);
    setFormValues({})
  };

   const loadInvoices = async () => {
      setIsLoading(true)
      let invoices = await getInvoicesList();
      setIsLoading(false)
      if (invoices && invoices.data && invoices.data.length > 0) {
        let array = []
        for (let index = 0; index < invoices.data.length; index++) {
          let element = invoices.data[index];
          element.unpaid_amount = Number((element?.invoice_amount ?? 0) - (element?.paid_amount ?? 0)).toLocaleString();
          element.invoice_amount = Number(element.invoice_amount ?? 0).toLocaleString();
          element.paid_amount = Number(element.paid_amount ?? 0).toLocaleString();
          element.invoice_date = moment(element.invoice_date).format('YYYY-MM-DD');
          array.push(element);       
        }  
        setInvoiceData(array)
      } 
    }

  const viewInvoice = (item) => {
    if (item) { 
      setFormValues(item);
      setSelectedItem(item);
      setTimeout(() => {
        setHideSaveButton(false)
        setIsDetails(true);   
        setIsPay(false);
        setIsEdit(false);
        setOpenForm(true);
      }, 300);
    }
  };

  const editInvoice = (item) => {
    if (item) {     
      setFormValues(item);
      setSelectedItem(item);
      setTimeout(() => {
        setHideSaveButton(true)
        setIsEdit(true);
        setIsPay(false);
        setIsDetails(false);  
        setOpenForm(true);
      }, 300);
    }
  };

  const payInvoice = (item) => {
    if (item) {     
      setFormValues(item);
      setSelectedItem(item);
      setTimeout(() => {
        setHideSaveButton(true)
        setIsPay(true);
        setIsEdit(false);
        setIsDetails(false);  
        setOpenForm(false);
      }, 300);
    }
  };

  const viewPayments = async (item) => {
    if (item) {     
      let paymentArr = [];
      let payments = await getPaymentsByInvoice({invoiceId: item?.id})
      for (let index = 0; index < payments.data.length; index++) {
        let element = payments.data[index];    
        paymentArr.push(element)    
      }
      setInvoicePayments(paymentArr)
      setSelectedItem(item);
      setTimeout(() => {
        setShowPayments(true);
      }, 300);
    }
  };

  const cancelInvoice = (item) => {
    if (item) {
      setFormValues(item)
      setSelectedItem(item)
      confirmCancel(item)
    }
  };

 

  const handleChange = (event) => {   
    //alert(JSON.stringify(event.target.value))
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value,
    });
  };


  const formInvoice = (schedule) => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="service_id"
              size="small"
              disabled={isDetails}
              inputType="select"
              value={formValues.service_id}
              defaultValue={{value:1,label:'Physiotherapy'}}
              label="Service Category"
              listLabel="Service Category"
              listValue="service_id"
              list={[{value:1,label:'Physiotherapy'},{value:2,label:'Home Nursing'}]}
              onChange={handleChange}
              error={errors["service_id"] ? true : false}
              helperText={errors["service_id"] ? errors.service_id[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="invoice_date"
              size="small"
              disabled={isDetails}
              label="Invoice Date"
              value={formValues.invoice_date}
              inputType="date"
              onChange={(e) =>
              handleChange({ target: { name: "invoice_date", value: e } })}
              error={errors["invoice_date"] ? true : false}
              helperText={errors["invoice_date"] ? errors.invoice_date[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="status"
              size="small"
              disabled={isDetails}
              inputType="select"
              value={formValues.status}
              defaultValue={{value:'active',label:'Active'}}
              label="Status"
              listLabel="Status"
              listValue="status"
              list={[{value:'active',label:'Active'}, {value:'paid',label:'Paid'}, {value:'removed',label:'Removed'}]}
              onChange={handleChange}
              error={errors["status"] ? true : false}
              helperText={errors["status"] ? errors.status[0] : null}
            />
          </div>
          
          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="invoice_amount"
              size="small"
              disabled={isDetails}
              label="Invoice amount"
              value={formValues.invoice_amount}
              inputType="number"   
              onChange={handleChange}
              error={!!errors["invoice_amount"]}
              helperText={errors["invoice_amount"] ? errors.invoice_amount[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="paid_amount"
              size="small"
              disabled={isDetails}
              label="Paid amount"
              value={formValues.paid_amount}
              inputType="number" 
              onChange={handleChange}
              error={!!errors["paid_amount"]}
              helperText={errors["paid_amount"] ? errors.paid_amount[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="invoice_no"
              size="small"
              disabled={true}
              label="Invoice number"
              value={formValues.invoice_no}
              inputType="text"   
              onChange={handleChange}
              error={!!errors["invoice_no"]}
              helperText={errors["invoice_no"] ? errors.invoice_no[0] : null}
            />
          </div>

          {/* <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="invoice_no"
              size="small"
              disabled={true}
              label="Paid amount"
              value={formValues.invoice_no}
              inputType="text"   
              onChange={handleChange}
              error={!!errors["invoice_no"]}
              helperText={errors["invoice_no"] ? errors.invoice_no[0] : null}
            />
          </div> */}
         

        </div>
      </>
    );
  };

  const formPayment = () => {
    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-6">
            <Inputs
              name="payment_date"
              size="small"
              // disabled={isDetails}
              label="Payment Date"
              value={formValues.payment_date}
              inputType="date"
              onChange={(e) =>
              handleChange({ target: { name: "payment_date", value: e } })}
              error={errors["payment_date"] ? true : false}
              helperText={errors["payment_date"] ? errors.payment_date[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="amount"
              size="small"
              // disabled={isDetails}
              label="Amount"
              value={formValues.amount}
              inputType="number"   
              onChange={handleChange}
              error={!!errors["amount"]}
              helperText={errors["amount"] ? errors.amount[0] : null}
            />
          </div>

          <div className="col-sm-12 col-md-12 col-12">
            <Inputs
              name="invoice_no"
              size="small"
              disabled={true}
              label="Invoice number"
              value={selectedItem?.invoice_no}
              inputType="text"   
              onChange={handleChange}
              error={!!errors["invoice_no"]}
              helperText={errors["invoice_no"] ? errors.invoice_no[0] : null}
            />
          </div>
         

        </div>
      </>
    );
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    //toast.success(JSON.stringify(formValues));
    let validationErrors = validate(
      formValues,
      invoiceSchema
    );
    if(validationErrors){
      setErrors(validationErrors);      
    }else{
      //toast.success(JSON.stringify(formValues));
      let payload = {
        //...formValues,
        customer_id: selectedItem?.customer_id,
        invoice_amount: formValues?.invoice_amount ?? selectedItem?.invoice_amount,
        invoice_no: selectedItem?.invoice_no,
        status: formValues?.status ?? selectedItem?.status,
        id: selectedItem?.id,
        service_id: formValues?.service_id ?? selectedItem?.service_id,
        paid_amount: formValues?.paid_amount ?? selectedItem?.paid_amount,
        invoice_date: formValues?.invoice_date ?? selectedItem?.invoice_date
      }

      setIsPosting(true)
      let updated = await putInvoice(payload);
      setIsPosting(false)
      if (updated.data?.mode === 'success') {
        loadInvoices()
        toast.success(updated.data.message ?? "Successful", {
          autoClose: 2600,
          hideProgressBar: true,
        });        
      }else{
        toast.error(updated.data.message ?? "Request has failed", {
          autoClose: 2600,
          hideProgressBar: true,
        });
      }
    }
  };

  const confirmCancel = async (item) => {
    let payload = {
      customer_id: selectedItem?.customer_id,
      invoice_amount: item?.invoice_amount ?? selectedItem?.invoice_amount,
      invoice_no: selectedItem?.invoice_no,
      status: 'removed',
      id: selectedItem?.id,
      service_id: item?.service_id ?? selectedItem?.service_id,
      paid_amount: item?.paid_amount ?? selectedItem?.paid_amount,
      invoice_date: item?.invoice_date ?? selectedItem?.invoice_date
    }
    let validationErrors = validate(
      payload,
      invoiceSchema
    );
    if(validationErrors){
      setErrors(validationErrors);      
    }else{
      setIsPosting(true)
      let updated = await putInvoice(payload);
      setIsPosting(false)
      if (updated.data?.mode === 'success') {
        loadInvoices()
        toast.success(updated.data.message ?? "Successful", {
          autoClose: 2600,
          hideProgressBar: true,
        });        
      }else{
        toast.error(updated.data.message ?? "Request has failed", {
          autoClose: 2600,
          hideProgressBar: true,
        });
      }
    }
  };

  const handleSubmitPayment = async (e) => {
    e?.preventDefault();
    //toast.success(JSON.stringify(formValues));
    let validationErrors = validate(
      formValues,
      paymentSchema
    );
    if(validationErrors){
      setErrors(validationErrors);      
    }else{
      //toast.success(JSON.stringify(formValues));
      let payload = {
        customer_id: selectedItem?.customer_id,
        amount: formValues?.amount,
        invoice_no: selectedItem?.invoice_no,
        invoice_id: selectedItem?.id,
        payment_date: formValues?.payment_date
      }

      setIsPosting(true)
      let updated = await postPayment(payload);
      setIsPosting(false)
      if (updated.data?.mode === 'success') {
        loadInvoices()
        toast.success(updated.data.message ?? "Successful", {
          autoClose: 2600,
          hideProgressBar: true,
        });        
      }else{
        toast.error(updated.data.message ?? "Request has failed", {
          autoClose: 2600,
          hideProgressBar: true,
        });
      }
    }
  };

  const paymentTable = () => {
    return (
      <div className="row">
        <div className="col-12">
          <div>
            <div className="card-body">
              {(
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Payment Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoicePayments.length > 0 ? (
                  invoicePayments.map((p, index) => (
                    <tr key={index}>
                      <td>{moment(p.payment_date).format('YYYY-MM-DD')}</td>
                      <td>{Number(p.amount ?? 0).toLocaleString()}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
         
              )}
            </div></div>
        </div></div>
    )
  }


  useEffect(() => {
    loadInvoices()
  }, [dispatch]);


  useEffect(() => {
    if (viewDetailsSelected === true && selectedItem) {
     // dispatch(getStockHistory({ item_code: selectedItem?.item_code }))
    }
  }, [viewDetailsSelected, selectedItem]);


  return (
    <div>
      <div className="ez-page-action">
        <h2 className="page-header">Customers Invoices</h2>
        
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card" style={{ backgroundColor: "#e0e0e0" }}>
            <div className="card-body">
              {isLoading === false ? (
                <Table
                  columns={itemsTableHead}
                  data={invoiceData}
                  actions={[
                    {
                      action: "Details",
                      renderCheck: (item) => {
                        if(isAdmin() && (item.status === 'active')){
                          return true
                        }else{
                          return false
                        }                        
                      },
                      onClick: (item) => {
                        viewInvoice(item);
                      },
                    },
                    {
                      action: "Edit",
                      renderCheck: (item) => {
                        if(isAdmin() && (item.status === 'active')){
                          return true
                        }else{
                          return false
                        }                        
                      },
                      onClick: (item) => {
                        editInvoice(item);
                      },
                    },
                    {
                      action: "Record Payment",
                      renderCheck: (item) => {
                        if(isAdmin() && (item.status === 'active')){
                          return true
                        }else{
                          return false
                        }                        
                      },
                      onClick: (item) => {
                        payInvoice(item);
                      },
                    },                    
                    {
                      action: "Cancel",
                      renderCheck: (item) => {
                        if(isAdmin() && (item.status === 'active')){
                          return true
                        }else{
                          return false
                        }                        
                      },
                      onClick: (item) => {
                        //editItem(item);
                        if (item.status === 'active') {
                          cancelInvoice(item)
                        }else{
                          
                        }
                        
                      },
                    },
                    {
                      action: "Show Payments",
                      renderCheck: (item) => {
                        if(isAdmin() && (item.status === 'active')){
                          return true
                        }else{
                          return false
                        }                        
                      },
                      onClick: (item) => {
                        if (item.status === 'active') {
                          viewPayments(item)
                        }else{
                          
                        }
                        
                      },
                    },
                  ]}
                  downloadFileName={"Customer Invoices"}
                />
              ) : isLoading === true ? (
                <MySpinner size={35} color="#367588" />
              ) : <></>
              }
            </div>
          </div>
        </div>
      </div>

      <MyDialog
        title={"Invoice for "+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile}
        width="sm"
        onClose={handleRequestClose}
        open={openForm}
        text={"Save Invoice"}
        content={() =>
          formInvoice(selectedItem && selectedItem.id ? selectedItem : null)
        }
        submit={async (e) => await handleSubmit(e)}
        hideSaveButton={!hideSaveButton}
        propBackgroundColor={"#367588"}
      />

      <MyDialog
        title={"Payment for "+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile}
        width="sm"
        onClose={handleRequestClose}
        open={isPay}
        text={"Save Payment"}
        content={() =>
          formPayment(selectedItem && selectedItem.id ? selectedItem : null)
        }
        submit={async (e) => await handleSubmitPayment(e)}
        hideSaveButton={!hideSaveButton}
        propBackgroundColor={"#367588"}
      />

      <MyDialog
        title={"Payments for invoice number "+selectedItem?.invoice_no+" ("+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile+")"}
        width="sm"
        onClose={handleRequestClose}
        open={showPayments}
        // text={"Save Payment"}
        content={() =>
          paymentTable()
        }
        //submit={async (e) => await handleSubmitPayment(e)}
        hideSaveButton={true}
        propBackgroundColor={"#367588"}
      />

    </div>
  );
};

export default Invoices;
